import React, { useEffect } from 'react';

export const Toast = ({ message, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="toast">
      <p>{message}</p>
      <button className="toastClose" onClick={onClose}>&times;</button>
    </div>
  );
};
